
import React from 'react';
import { ImageOptimizer } from '@/components/common/ImageOptimizer';

const FooterLogo = () => {
  return (
    <div>
      <div className="mb-3">
        <ImageOptimizer 
          alt="Cutshort Logo" 
          className="h-8" 
          src="/lovable-uploads/6d37c55d-8560-47cc-aea4-88bb51dd7cf1.png" 
          width={120}
          height={40}
        />
      </div>
      <p className="text-brand-grey max-w-xs">
        Be less busy. Make smart hires.
      </p>
    </div>
  );
};

export default FooterLogo;
